const QUESTION_TYPE_LISTENING_TIME = 30;

export const getQuestionTypeListeningTime = ({
  isQuestionTypeMock,
  mockTestType,
  questionTypeName,
  configuredTime,
}) => {
  if (
    isQuestionTypeMock &&
    mockTestType === "Listening" &&
    questionTypeName !== "Summarize Spoken Text"
  ) {
    return QUESTION_TYPE_LISTENING_TIME;
  }

  return configuredTime;
};
